import Axios from 'axios'

const axios = Axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Access-Control-Allow-Origin': `${process.env.VUE_APP_API_URL}/api`,
    'access-control-allow-headers': 'Authorization',
  },
})

const getAllFinancialSubCategories = async () => {
  return axios.request({
    method: 'GET',
    url: '/api/financial-subcategories',
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const saveFinancialSubCategory = async (data: Record<string, string>) => {
  return axios.request({
    method: 'POST',
    url: '/api/financial-subcategories',
    data,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const updateFinancialSubCategory = async ({ id, ...data }) => {
  return axios.request({
    method: 'patch',
    url: `/api/financial-subcategories/${id}`,
    data: { id: id, ...data },
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const deleteFinancialSubCategory = async id => {
  return axios.request({
    method: 'DELETE',
    url: `/api/financial-subcategories/${id}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

export default {
  getAllFinancialSubCategories,
  saveFinancialSubCategory,
  deleteFinancialSubCategory,
  updateFinancialSubCategory,
}
